import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { LocationAcquisitionService } from '../services/location-acquisition.service';

const ensureCoordinates: CanActivateFn = (_route, _state) => {
  const locationAcquisitionService = inject(LocationAcquisitionService);

  locationAcquisitionService.ensureInitialCoordinates().catch((error) => {
    console.error('Unable to obtain coordinates before avatar route activation:', error);
  });

  return true;
};

export const avatarLocationCanActivate: CanActivateFn = ensureCoordinates;
